const CreditPlanCategories = {
  EXPIRING: "EXPIRING",
  NON_EXPIRING: "NON_EXPIRING",
  PAY_AS_USAGE: "PAY_AS_USAGE"
};

export default CreditPlanCategories;
